import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../../Components/Header/Header";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import TopMenu from '../../../../Components/TopMenu/TopMenu';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AssetsIcon from "../../../../assets/images/assets.svg";
import OperationIcon from "../../../../assets/images/oparation.svg";
import AssetsIconA from "../../../../assets/images/assets_a.svg";
import OperationIconA from "../../../../assets/images/oparation_a.svg";
import { withRFSToken } from '../../../../Services/axios.js';
import { faDownload, } from "@fortawesome/free-solid-svg-icons";
import Dashboard from './Dashboard';
import Chart from './Chart';
import { saveAs } from "file-saver";
import ChartDown from "../../../../assets/images/chart_download.png";
import { Link } from "react-router-dom/cjs/react-router-dom";
const StockAllotment = () => {

    const initialTab = "dashboard";
    const [selectedButton, setSelectedButton] = useState(initialTab);
    const handleButtonClick = async (button) => {
        if (button === 'export') {
            try {
                const res = await withRFSToken.post('export-stock-allotment', {},
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        },
                        responseType: 'blob',
                    }
                ).then(response => {
                    const now = new Date();
                    const formattedDateTime = `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
                    const blob = new Blob([response.data], { type: response.headers['content-type'] });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `exported-data-${formattedDateTime}-downloaded.xlsx`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else {
            setSelectedButton(button);
        }
    };
    return (
        <div className="">
            <Header page_type='uld' logo_url='/ULDControl' />
            <div className="page-body-wrapper schedule">
                <LeftMenu />
                <div className="main-panel rounded">
                    <div className="mainTab">
                        <div className="allcontent-fl">
                            <div className='d-flex justify-content-between mb-3'>
                                <div>
                                    <button className={selectedButton === 'dashboard' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('dashboard')}>
                                        <img src={selectedButton === 'dashboard' ? AssetsIconA : AssetsIcon} /> <span>Dashboard</span>
                                    </button>
                                    <button className={selectedButton === 'chart' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('chart')}>
                                        <img src={selectedButton === 'chart' ? OperationIconA : OperationIcon} /> <span>Chart</span>
                                    </button>
                                </div>
                                <div>
                                    <div className="chart_filter me-2"> <Link to="#" onClick={() => handleButtonClick('export')}> <img src={ChartDown} ></img> </Link></div>
                                </div>
                            </div>
                            {selectedButton === 'dashboard' && <Dashboard />}
                            {selectedButton === 'chart' && <Chart />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StockAllotment